module.exports = __webpack_public_path__ + "static/media/enterprise_flag_icon.257b8146.svg";